import { render } from "./StyleSelector.vue?vue&type=template&id=732ca174&scoped=true"
import script from "./StyleSelector.vue?vue&type=script&lang=js"
export * from "./StyleSelector.vue?vue&type=script&lang=js"

import "./StyleSelector.vue?vue&type=style&index=0&id=732ca174&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732ca174"]])

export default __exports__